module.exports = __webpack_public_path__ + "static/media/8OLA26.3e000b52.jpg";